const renderParagraphs = (paragraphs, styles) => {
  if (!Array.isArray(paragraphs) || paragraphs.length === 0) return null;

  return paragraphs.map((text, index) => {
    const style =  styles.paragraph;
    return (
      <p key={`${index}-${text.slice(0, 10)}`} style={style}>
        {text}
      </p>
    );
  });
};

export const getPotentialWeaknessParagraphs = (flowHead, styles) => {
  if (flowHead == "HEART TO SOUL") {
    return renderParagraphs([
      `This type of group is grounded in feelings and meaning, valuing inner experiences and simply "being" over outward actions and achievements.`,
      `A Heart-to-Soul group is guided by identity, values, and purpose. Rather than leading from the front, they create environments where life, love, and leadership can flourish naturally.`,
      `Often seen as poets or creatives, they focus on soulful, intangible influence rather than conventional, straightforward strategies.`,
    ], styles);
  }
  if (flowHead == "HEART TO MIND") {
    return renderParagraphs([
      `The Heart-to-Mind group feels first and thinks second. They start by caring, then add understanding to what’s already unfolding. Once they feel grounded, they begin to strategize. Though much of this process happens within, they always bring it back to relationships, where they can openly explore and refine their ideas.`,
      `This group combines emotional connection with intellectual insight, creating a style that’s both compassionate and strategically strong.`,
    ], styles);
  }
  if (flowHead == "HEART TO STRENGTH") {
    return renderParagraphs([
      `The Heart-to-Strength group is fueled by emotional energy and a focus on action. They’re naturally driven by their feelings, wants, and needs, which motivate them to get things done.`,
      `For them, shifting from heart to strength means moving from simply “being” to actively “doing”—from experiencing and connecting to making things happen in a tangible, practical way.`,
    ], styles);
  }
  if (flowHead == "SOUL TO MIND") {
    return renderParagraphs([
      `These groups begin with depth, meaning, and vision, creating ideas to bring their insights to life. They organize and structure their inner world, and if they need a new structure, they’ll invent it.`,
      `However, their carefully crafted plans can sometimes be hard to put into practice because they’re based on big ideas and philosophy.`,
    ], styles);
  }
  if (flowHead == "SOUL TO STRENGTH") {
    return renderParagraphs([
      `Soul-to-Strength groups quickly turn deep insights into action. They skip long planning phases, bringing the soul's depth straight into real-world impact.`,
      `Even without strong strategic or relational backing, their drive and commitment often lead to impressive, unexpected results.`,
    ], styles);
  }
  if (flowHead == "SOUL TO HEART") {
    return renderParagraphs([
      `Soul-to-Heart groups prioritize presence, relational depth, and meaningful connections. With an innate ability to connect emotionally, they inspire trust and loyalty through their genuine, authentic nature. They navigate life thoughtfully, seeing beyond the surface.`,
      `However, they may struggle in environments that value speed, competition, and strategy over depth and authenticity.`,
    ], styles);
  }
  if (flowHead == "MIND TO STRENGTH") {
    return renderParagraphs([
      `Groups moving from Mind to Strength blend clear thinking with action. They’re the “think smarter, work harder” type, constantly tweaking their strategies to get better results.`,
      `Focused on practical information and efficiency, they may sometimes overlook creativity, curiosity, or others’ needs.`,
      `Mind-to-Strength groups are direct, preferring to explain or show their ideas clearly, making them easy to understand.`,
    ], styles);
  }
  if (flowHead == "MIND TO HEART") {
    return renderParagraphs([
      `The Mind-to-Heart shift moves from logic to emotional connection, from head to heart.`,
      `These groups, especially if relationally focused, prefer thoughtful and inclusive approaches over taking control. They need a deep understanding before they can fully invest or invite others in.`,
      `Their clear thinking often brings calm to those seeking direction. Once they have a solid plan, they’re ready to welcome others on board.`,
    ], styles);
  }
  if (flowHead == "MIND TO SOUL") {
    return renderParagraphs([
      `Groups on the Mind-to-Soul path start with a clear plan and gradually seek deeper meaning, aiming to fit their ideas into a bigger, more meaningful picture.`,
      `They commit to projects that match both their logical thinking and personal values, making their work both effective and fulfilling.`,
      `However, they may have many ideas and insights without taking much action, which can make them appear insightful but hard to pin down.`,
    ], styles);
  }
  if (flowHead == "STRENGTH TO HEART") {
    return renderParagraphs([
      `Strength-to-Heart groups dive into their missions with enthusiasm and passion, often bringing a welcoming attitude that quickly draws others in.`,
      `They’re natural motivators, using confidence, directness, and genuine empathy to kick-start projects and keep them going through emotional connection.`,
      `Their strong drive builds initial connections, but these relationships can be tested if goals or plans change. If others aren’t aligned with their direction, they may be left behind.`,
    ], styles);
  }
  if (flowHead == "STRENGTH TO SOUL") {
    return renderParagraphs([
      `Strength-to-Soul groups are dynamic visionaries who seek deeper meaning in their work, beyond just hitting goals.`,
      `They aim for their efforts to carry real significance, aligning personal values with professional goals. This means balancing practical actions with bigger visions to make their ideas a reality.`,
      `Their high standards and shift toward purpose-driven goals can sometimes confuse or distance teammates used to simpler, more direct tasks. But despite these challenges, Strength-to-Soul groups inspire others by showing how work can be both successful and deeply meaningful.`,
    ], styles);
  }
  if (flowHead == "STRENGTH TO MIND") {
    return renderParagraphs([
      `Strength-to-Mind groups are fueled by action and a constant urge to make things better, always asking, “How can this improve?” This relentless drive for progress helps them advance quickly and find success.`,
      `With a sharp focus on strategy and results, they sometimes overlook the emotional or cultural side of things, leaning toward efficiency over deeper relationships or cultural awareness. While they excel at getting things done, they may miss the nuances that create a more connected, balanced environment.`,
    ], styles);
  }

  return null;
};

export const getPotentialStrengths = (flowHead, styles) => {
  if (flowHead == "HEART TO SOUL") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Deep Connections and Emotional Engagement</div>
      <div style={styles.pointText}>• Values-Driven Purpose</div>
      <div style={styles.pointText}>• Creativity and Innovation</div>
    </div>
  }
  else if (flowHead == "HEART TO MIND") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Balanced Decision-Making</div>
      <div style={styles.pointText}>• Compassionate Leadership</div>
      <div style={styles.pointText}>• Emotionally Healthy Group Culture</div>
    </div>
  }
  else if (flowHead == "HEART TO STRENGTH") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• High Motivation and Energy</div>
      <div style={styles.pointText}>• Strong Connection and Culture</div>
      <div style={styles.pointText}>• Considerate Performance Expectations</div>
    </div>
  }
  else if (flowHead == "SOUL TO MIND") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Inspirational Leadership</div>
      <div style={styles.pointText}>• Deep Insight with Structural Support</div>
      <div style={styles.pointText}>• Creative Thinking and Problem-Solving</div>
    </div>
  }
  else if (flowHead == "SOUL TO STRENGTH") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Turning Ideas into Action</div>
      <div style={styles.pointText}>• Making Abstract Ideas Practical</div>
      <div style={styles.pointText}>• Creative Commitment</div>
    </div>
  }
  else if (flowHead == "SOUL TO HEART") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Authentic and Supportive Presence</div>
      <div style={styles.pointText}>• Advocates for Qualitative Metrics</div>
      <div style={styles.pointText}>• Contemplative and Considerate</div>
    </div>
  }
  else if (flowHead == "MIND TO STRENGTH") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Analytical Thinking and Practical Action</div>
      <div style={styles.pointText}>• Continuous Improvement</div>
      <div style={styles.pointText}>• Clear Communication for Measurable Success</div>
    </div>
  }
  else if (flowHead == "MIND TO HEART") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Strategic Inclusivity</div>
      <div style={styles.pointText}>• Balanced Decision-Making</div>
      <div style={styles.pointText}>• Unlocking Logical and Emotional Integration</div>
    </div>
  }
  else if (flowHead == "MIND TO SOUL") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Strong Ethical Foundations</div>
      <div style={styles.pointText}>• Purpose-Driven Planning</div>
      <div style={styles.pointText}>• Inspirational Leadership</div>
    </div>
  }
  else if (flowHead == "STRENGTH TO HEART") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Natural Motivation and Drive</div>
      <div style={styles.pointText}>• Carriers of Team Spirit and Culture</div>
      <div style={styles.pointText}>• Enthusiastic and Inclusive   </div>
    </div>
  }
  else if (flowHead == "STRENGTH TO SOUL") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Modeling Practical Purpose</div>
      <div style={styles.pointText}>• Performance-Driven Inspiration   </div>
    </div>
  }
  else if (flowHead == "STRENGTH TO MIND") {
    return <div style={styles.pointsContainer}>
      <div style={styles.pointsHeader}>POTENTIAL STRENGTHS</div>
      <div style={styles.pointText}>• Fast and Efficient Problem Solvers</div>
      <div style={styles.pointText}>• High-Performers who Stick to the Plan</div>
      <div style={styles.pointText}>• Practical Strategists</div>
    </div>
  }
}

export const getPotentialWeakness = (flowHead, styles) => {
  if (flowHead == "HEART TO SOUL") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Lack of Focus on Practical Execution</div>
      <div style={styles.pointText}>• Potential for Overemphasis on Consensus</div>
      <div style={styles.pointText}>• Risk of Isolation or Impracticalities</div>
    </div>
  }
  else if (flowHead == "HEART TO MIND") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Potential for Delayed Decision-Making</div>
      <div style={styles.pointText}>• Difficulty Stewarding Emotions and Logic</div>
      <div style={styles.pointText}>• Vulnerability to Emotional Bias</div>
    </div>
  }
  else if (flowHead == "HEART TO STRENGTH") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Risk of Impulsiveness</div>
      <div style={styles.pointText}>• Difficulty in Sustaining Momentum</div>
      <div style={styles.pointText}>• Potential Over-reliance on Passion and Emotion</div>
    </div>
  }
  else if (flowHead == "SOUL TO MIND") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Overcomplicating Processes</div>
      <div style={styles.pointText}>• Resistance to Change</div>
      <div style={styles.pointText}>• Abstractness Leading to Communication Gaps</div>
    </div>
  }
  else if (flowHead == "SOUL TO STRENGTH") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Lack of Strategic Planning</div>
      <div style={styles.pointText}>• Relational and Cultural Oversight</div>
      <div style={styles.pointText}>• Misunderstood and Impulsive</div>
    </div>
  }
  else if (flowHead == "SOUL TO HEART") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Slow Decision-Making</div>
      <div style={styles.pointText}>• Overpowered by Competitive Environments </div>
      <div style={styles.pointText}>• Impractical and Emotionally Complex</div>
    </div>
  }
  else if (flowHead == "MIND TO STRENGTH") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• High Potential for Burnout</div>
      <div style={styles.pointText}>• Impersonal Approaches</div>
      <div style={styles.pointText}>• Neglecting Emotional and Creative Needs </div>
    </div>
  }
  else if (flowHead == "MIND TO HEART") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• At Risk of Overthinking and Underperforming </div>
      <div style={styles.pointText}>• Difficulty in Handling Conflict</div>
      <div style={styles.pointText}>• Struck Between Logical and Emotional Consideration</div>
    </div>
  }
  else if (flowHead == "MIND TO SOUL") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Overly Idealistic and Struggles to Scale</div>
      <div style={styles.pointText}>• Unaware or Inconsiderate of Culture </div>
      <div style={styles.pointText}>• Action Deficiency </div>
    </div>
  }
  else if (flowHead == "STRENGTH TO HEART") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Exclusivity and Elitism</div>
      <div style={styles.pointText}>• Dependency on Motivation and Enthusiasm</div>
      <div style={styles.pointText}>• Transactional Relationships</div>
    </div>
  }
  else if (flowHead == "STRENGTH TO SOUL") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Implementation Confusion</div>
      <div style={styles.pointText}>• Inconsistent Deliverables</div>
      <div style={styles.pointText}>• Overlooking Relational and Strategic Dynamics  </div>
    </div>
  }
  else if (flowHead == "STRENGTH TO MIND") {
    return <div style={styles.contentContainer}>
      <div style={styles.pointsHeader}>POTENTIAL WEAKNESSES</div>
      <div style={styles.pointText}>• Qualitative Leadership Deficient </div>
      <div style={styles.pointText}>• Burnout From High Stress and Pressure</div>
      <div style={styles.pointText}>• Lack of Creativity and Imagination </div>
    </div>
  }
}
